import {
  BrowserRouter,
  // Route,
  // Routes,
  // Navigate,
  useRoutes,
} from "react-router-dom"
import Header from "@/component/header"
import Footer from "@/component/footer"
import NotFound from "@/pages/notFound"
import Home from "@/pages/home/index"
import College from "@/pages/college/index"
import CollegeDetail from "@/pages/college/detail"
import ClassType from "@/pages/classtype"
import Information from "@/pages/information"


const RouteList = () => {
  const routes = [
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/college",
      element: <College />,
    },
    {
      path: "/college/:id",
      element: <CollegeDetail />,
    },
    {
      path: "/classType",
      element: <ClassType />,
    },
    {
      path: "/Information",
      element: <Information />,
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ]

  // routes.forEach((route) => {
  //   route.element = Interceptor(route)
  // });
  // console.log(routes);

  return useRoutes(routes)
}

export default function render() {
  return (
    <div className="page-layout">
      <div className="page-container">
        <BrowserRouter>
          <Header />
          <RouteList />
          <Footer />
        </BrowserRouter>

        {/* <Routes>
            <Route exact path="/" element={<Home />}></Route>
            <Route exact path="/college" element={<College />}></Route>
            <Route
              exact
              path="/college/:id"
              element={<CollegeDetail />}
            ></Route>
            <Route exact path="/classType" element={<ClassType />}></Route>
            <Route exact path="/Information" element={<Information />}></Route>
            <Route path="/notFound" element={<NotFound />} />
            <Route
              path="*"
              element={<Navigate replace to="/notFound" />}
            ></Route>
          </Routes> */}
      </div>
    </div>
  )
}
